import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries'
import { GlobalContext } from '../../../App';
import { useAddData, useGetDataByName, useUpdateData, updateOrAddItem } from '../../dataLocal/indexedDBHooks';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const useBlockQueries = () => {
  const { setDataBlocks, userId, db } = useContext(GlobalContext)
  const { AllDataEntities, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries()

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataBlocks = async () => {
    try {
      let query = `api/blocks/getBlocks`
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`
      let nameEntity = 'dataBlocks'

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataBlocks(data?.resData || [])
      if (db) {
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 2, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 2, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }

    } catch (error) {
      console.error("שגיאה בטעינת נתונים: ", error);
    }
  }

  const addOrUpdateDataBlock = async (data, unicId) => {
    let create = `api/blocks/addBlock`
    let update = `api/blocks/updateBlock`
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${(data?.id) ? update : create}`
    
    let ip = ''
    // דוגמה לשימוש בפונקציה
    await getUserIP().then(myIp => {
      ip = myIp
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'blocks',
      actionType: (data?.unicId) ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
    };

    if (!data?.unicId) {
      data = {
        ...data,
        unicId: unicId
      }
    }

    try {
      let res = await addOrUpdateDataEntity2(data, payload, url);
      if (res) {
        await updateOrAddItem(db, 'myStore', data, 'dataBlocks', 2 );
        console.log('התוצאה הצליחה...')
        return res
      } else {
        return false
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false
    }
  }

  const removeBlock = (id) => {
    let query = `api/blocks/removeBlock`
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`
    removeEntity(id, url)
  }

  return {
    AllDataBlocks,
    addOrUpdateDataBlock,
    removeBlock
  }
};

export default useBlockQueries;
